import { type ComponentPropsWithoutRef, memo } from 'react';

import { cn } from '@air/utils-tailwind';

export type ContentCollectionPageHeaderProps = ComponentPropsWithoutRef<'header'>;

export const ContentCollectionPageHeader = memo(({ className, ...restOfProps }: ContentCollectionPageHeaderProps) => {
  return (
    <header
      className={cn('flex h-14 items-center justify-between ads:bg-base bg-gray-1 px-4', className)}
      {...restOfProps}
    />
  );
});

ContentCollectionPageHeader.displayName = 'ContentCollectionPageHeader';
